// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3q-Ca","search":"Settings_search__3z4X6","filter":"Settings_filter__28tLC"};